import { PATTERNS } from '../../../constants/validations';

export function decodeQueryParams(value) {
  if (value === null || value === undefined) return value;
  const map = {
    '+': '%2B',
    '-': '%2D',
    _: '%5F',
    '@': '%40',
    '.': '%2E',
  };
  return String(value).replace(PATTERNS.CHARACTERS, ch => map[ch]);
}



// WEBPACK FOOTER //
// ./src/components/Auth/utils/decodeQueryParams.js